import { getCommon } from '@/api/wallet';

const defaultState = {
  hasBattery: false,
  packageInfo: [],
  userValidOrderInfo: [],
  deposit: null,
  authType: '',
  packageFlag: 0,
  hasGetData: false,
};

const wallet = {
  namespaced: true,
  state: {
    ...defaultState,
  },

  mutations: {
    SET_STATE: (state, nextState) => {
      Object.assign(state, defaultState, nextState, {
        hasGetData: true,
      });
    },
  },

  actions: {
    // 获取钱包信息
    getCommon({ commit }) {
      return getCommon()
        .then((response) => {
          commit('SET_STATE', response);
          return response;
        });
    },
  },
};

export default wallet;
